import { render } from "./HelloBusiness.vue?vue&type=template&id=8fc02af4&scoped=true"
import script from "./HelloBusiness.vue?vue&type=script&lang=js"
export * from "./HelloBusiness.vue?vue&type=script&lang=js"

import "./HelloBusiness.vue?vue&type=style&index=0&id=8fc02af4&lang=scss&scoped=true"

import exportComponent from "/tmp/build_195c5171/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fc02af4"]])

export default __exports__